
const obtenerUltimoEjercicio= (codigo) => {
        const semana = parseInt(codigo.slice(0, 2), 10);
        const dia = parseInt(codigo.slice(2, 4), 10);
        const sesion = parseInt(codigo.slice(4, 7), 10);
        const ejercicio = parseInt(codigo.slice(7, 9), 10);

        return `Semana: ${semana}, día: ${dia}, sesión: ${sesion}, ejercicio: ${ejercicio}`;
    }



const columnsEstudiantesUveg = [
    {
        header: "Matrícula",
        accessorKey: "matricula",
        sortable: true,
        center: true,
        compact: true,
        width: "200px",
    },
    {
        header: "Nombre completo",
        accessorKey: "nombre",
        sortable: true,
        center: true,
        compact: true,
        width: "40px",
    },
    {
        header: "Correo institucional",
        accessorKey: "correoInstitucional",
        sortable: true,
        center: true,
        compact: true,
        width: "360px",
    },
    {
        header: "ppm",
        accessorKey: "palabrasPorMinuto",
        sortable: true,
        center: true,
        compact: true,
        width: "360px",
    },
    {
        header: "Comprensión",
        accessorKey: "comprension",
        sortable: true,
        center: true,
        compact: true,
        width: "360px",
    },
    {
        header: "Ultimo Ejercicio",
        accessorKey: "ultimoEjercicio",
        sortable: true,
        center: true,
        compact: true,
        width: "360px",
        Cell: ({ cell }) => (
            <div className="text-center">
                <span>{(cell.row.original.ultimoEjercicio === 'Sin avance' || cell.row.original.ultimoEjercicio === 'Curso terminado' || cell.row.original.ultimoEjercicio === 'Comenzando el curso') ? cell.row.original.ultimoEjercicio : obtenerUltimoEjercicio(cell.row.original.ultimoEjercicio)} </span>
            </div>
        ),
    },
   
];

export default columnsEstudiantesUveg;
